<template>
    <div>
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12 md6>
                    <v-text-field
                        v-model="name"
                        v-validate="'required'"
                        label="First Name *"

                        required
                        :error-messages="errors.collect('First Name')"
                        data-vv-name="First Name"
                    />
                </v-flex>

                <v-flex xs12 md6>
                    <v-text-field
                        v-model="surname"
                        v-validate="'required'"
                        label="Surname *"

                        required
                        :error-messages="errors.collect('Surname')"
                        data-vv-name="Surname"
                    />
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                        v-model="username"
                        v-validate="'required'"
                        label="Username *"

                        required
                        :error-messages="errors.collect('Username')"
                        data-vv-name="Username"
                    />
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                        v-model="email"
                        v-validate="'required|email'"
                        label="Email *"

                        required
                        :error-messages="errors.collect('Email')"
                        data-vv-name="Email"
                    />
                </v-flex>

                <v-flex xs12>
                    <v-text-field
                        v-model="password"
                        v-validate="'required'"
                        label="Password *"
                        type="password"
                        required
                        :error-messages="errors.collect('Password')"
                        data-vv-name="Password"
                        autocomplete="off"
                    />
                </v-flex>

                <v-flex xs12>
                    <v-autocomplete
                        v-model="selectedDepartment"
                        :items="DepartmentOptions"
                        item-text="name"
                        item-value="value"
                        label="Department "
                        clearable
                    />
                </v-flex>

                <v-flex xs12>
                    <v-autocomplete
                        v-model="selectedRole"
                        v-validate="'required'"
                        :items="RoleOptions"
                        item-text="name"
                        item-value="name"
                        label="Roles *"

                        clearable
                        :error-messages="errors.collect('Roles')"
                        data-vv-name="Roles"
                    />

                    <span class="role-permisison-link" @click="$_navigateTo_NewPage('RolePermissionsTable')">View System Role Permission Info</span>
                </v-flex>
            </v-layout>
            <br>
            <v-btn color="primary" class="save-btn margin0" @click="createUser()">Save</v-btn>
        </v-container>
    </div>
</template>

<script>
import { createUserV2 } from "@/api/user";

export default {
    name: "AddUser",
    props: ["comfirmFn"],

    data () {
        return {
            RoleOptions: [],
            selectedRole: null,
            DepartmentOptions: [],
            selectedDepartment: null,
            name: null,
            surname: null,
            username: null,
            password: null,
            email: null,
        };
    },
    watch: {
        comfirmFn() {
            if (this.comfirmFn == true) {
                this.comfirmCreate();
            }
        }
    },
    mounted() {
        this.getRoles();
        this.getDepartment();
    },
    methods: {
        getRoles() {
            var self = this;
            axios({
                method: "GET",
                url: "Role/GetAllForDropdown",
            }).then(function (response) {
                self.RoleOptions = response.data.result;
            });
        },
        getDepartment() {
            var self = this;
            axios({
                method: "GET",
                url: "Department/GetAllForDropdown",
            }).then(function (response) {
                self.DepartmentOptions = response.data.result;
            });
        },
        createUser() {
            var self = this;
            this.$validator.validateAll().then(result => {
                if (result) {
                    // this.$store.commit('callCreateAlert', {
                    //   isCreateAlert: true,
                    //   title: 'Are you sure',
                    //   description: 'Are you sure to create new user?'
                    // });
                    EventBus.$emit("confirmDialog", {
                        text: "Are you sure to create new user?",
                        id: 1,
                    });
                }
            });
        },
        async comfirmCreate() {
            let res = await createUserV2({
                "name": this.name,
                "surname": this.surname,
                "userName": this.username,
                "password": this.password,
                "emailAddress": this.email,
                "departmentId": this.selectedDepartment,
                "roleNames": [this.selectedRole],
                "isActive": true,
            });
            if (res) {
                EventBus.$emit("snackBar", {
                    text: "New User Added",
                    snackbarColor: "green darken-2"
                });
                this.selectedRole = null;
                this.selectedDepartment = null;
                this.name = null;
                this.password = null;
                this.surname = null;
                this.username = null;
                this.email = null;
                // this.errors.items = [];         
                // this.reloadTable("#userList");
                // this.active = 0;
            }
            this.$emit("update:comfirmFn", false);
        }
    }
};
</script>

<style lang="css" scoped>
.role-permisison-link{
	font-size: 12px;
	color: var(--main-color-blue)
}
.role-permisison-link:hover{
	font-size: 12px;
	text-decoration: underline;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/UMS/UserManagement/AddUser.vue